module.exports = __webpack_public_path__ + "static/argon-logo--element-13795bdae52b9e46c83627b2974586a5.jpg";